module.exports = __webpack_public_path__ + "static/img/stikesntb.f131e66.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/stikesntb.jpeg
// module id = SsUy
// module chunks = 8